import { FadeUp } from "./Reveal";
import { IMAGES } from "../i18n";

export const Founder = ({ t }) => (
  <section id="founder" className="py-28 md:py-44 bg-sand border-t border-ink/10" data-testid="founder-section">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6 items-center">
      <FadeUp className="col-span-12 md:col-span-10 md:col-start-2">
        <div className="relative aspect-[4/5] overflow-hidden bg-stone">
          <img src={IMAGES.portrait} alt="Ginette Figarella on set" loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-testid="founder-portrait" />
        </div>
        <p className="font-sans text-[10px] uppercase tracking-[0.25em] text-ink/40 mt-4">{t.founder.caption}</p>
      </FadeUp>
    </div>
  </section>
);
